







  import { Component, Vue } from 'vue-property-decorator';

@Component({
  name:"Command"
})
export default class Profil extends Vue {}
